import { ArticleParagraph1 } from '@cian/ui-kit';
import React, { PropsWithChildren } from 'react';

import styles from './styles.css';

export const FAQAccordionContentLayout: React.FC<PropsWithChildren> = props => {
  return (
    <ArticleParagraph1 as="div">
      <div className={styles['layout']}>{props.children}</div>
    </ArticleParagraph1>
  );
};
